export default __webpack_public_path__ + "static/media/Group 626075.5a81d6d9.svg";